import React, { useState } from 'react'
import './SalesOnlineOfflineFilter.scss'

const SalesOnlineOfflineFilter = ({ onFilterChange, currentType = '' }) => {
  const [active, setActive] = useState(currentType)

  const handleClick = (type) => {
    setActive(type)
    onFilterChange(type)
  }

  return (
    <div className="sales-filter">
      <button
        className={`filter-btn all ${active === '' ? 'active' : ''}`}
        onClick={() => handleClick('')}
      >
        All
      </button>

      <button
        className={`filter-btn online ${active === 'ONLINE' ? 'active' : ''}`}
        onClick={() => handleClick('ONLINE')}
      >
        Online
      </button>

      <button
        className={`filter-btn offline ${active === 'IN_STORE' ? 'active' : ''}`}
        onClick={() => handleClick('IN_STORE')}
      >
        In Store
      </button>
    </div>
  )
}

export default SalesOnlineOfflineFilter
